import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=067aee37&lang=html"
import script from "./weight.js?vue&type=script&lang=js&external"
export * from "./weight.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports